import React, { useEffect, useMemo, useState } from "react";
import Button from 'react-bootstrap/Button';

import UsernameForm from "../../../Login/UsernameForm";

import GoogleButton from "../../TO/Login/GoogleButton";
import FacebookButton from "../../TO/Login/FacebookButton";
import AppleButton from "../../TO/Login/AppleButton";
import AppVars from "../../../../AppVars.js";

import { USER_ID_QUERY_PARAM } from "../../../../constants/constants";
import { useGotoUrlContext } from "../../../../withGotoUrl";
let appVars = AppVars.getInstance();

const LoginPageViewMobile = (props) => {
  const [username, setUsername] = useState("");
  const [emailEncrypted, setEmailEncrypted] = useState("");
  const gotoUrlContext = useGotoUrlContext();
  const [showAlert, setShowAlert] = useState(false);

  const changeUserName = (value) => {
    let digitsOnly = value.replace(/\D/g, '');
    if(digitsOnly === value && value.length >= 4){
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }
    setUsername(value);
  }

  useEffect(() => {
    //console.log("gotoUrlContext",gotoUrlContext);
    setUsername(gotoUrlContext.initialUsername);
    setEmailEncrypted(gotoUrlContext.decryptEmail);
  }, [gotoUrlContext.initialUsername]);

 const createAccountHref = useMemo(() => {
    const registerUrl = appVars.getRegisterURL(props.style);
    try {
      const url = new URL(registerUrl);
      if (username) {
        //url.searchParams.append(USER_ID_QUERY_PARAM, encrypt(username));
        url.searchParams.append(USER_ID_QUERY_PARAM, emailEncrypted);
      }
      return url.href;
    } catch (error) {
      return registerUrl;
    }
  }, [props.style, username]);

  return (
    <div className="login-wrapper">
      <div className="relative login-box">
        <div
          id="usernameUnlinked"
          className={`${
            props.isUsernameExists === false ? "error-modal" : "none"
          }`}
          role="alert"
          aria-hidden={!!props.isUsernameExists}
        >
          <div className="error-modal-text">
            <b>{props.displayPhone}</b> isn't linked to an account. Please try a
            different sign in.
          </div>
          <span onClick={props.hideModalUsername} className="modal-close">
            &times;
          </span>
        </div>
        <div
          id="accountLocked"
          className={`${
            props.isAccountLocked === true ? "error-modal" : "none"
          }`}
          role="alert"
          aria-hidden={!props.isAccountLocked}
        >
          <div className="error-modal-text">
            This account has been locked due to multiple failed attempts. Please try again later.{" "}
            <a
              role="button"
              tabIndex="0"
              style={{ cursor: 'pointer' }}
              onClick={() => window.location.replace(appVars.getForgotPasswordURL(props.style))}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  window.location.replace(appVars.getForgotPasswordURL(props.style));
                }
              }}
            >
              <u>Click here to Reset Password</u>
            </a>
          </div>
          <span onClick={props.hideModalLocked} className="modal-close">
            &times;
          </span>
        </div>
        {/* <div className = "title-padding"></div> */}
        <div className="title__TO left">Sign in</div>
        <a href={appVars.getAppHomeURL(props.style)}>
          <img
            src={require("../../../../static/images/Toyota-Logo.svg").default}
            className="login-logo__TO absolute"
            alt="Toyota Owners"
          ></img>
        </a>
        <div className="sign-in-grid">
          <div className="sign-in-subtitle-left sign-in-subtitle">
            Use your email or mobile number
          </div>
          {showAlert && <div
            className="sign-in-subtitle-left sign-in-subtitle"
            id="phone-consent-msg"
          >
            By clicking Next Step below, you confirm that you are the owner or
            primary user of the mobile phone number provided. You agree to
            receive automated text messages to confirm your phone number.
            Message and data rates may apply.
          </div>}
          <div className="sign-in-subtitle-right sign-in-subtitle" id={showAlert ? 'subtitle-alert' : ''}>
            Continue with Single Sign-On
          </div>
          <div className="sign-in-form">
            <UsernameForm
              username={username}
              handleUsernameChange={(username) => changeUserName(username)}
              style={props.style}
              saveURI={props.saveURI}
              saveDisplayPhone={props.saveDisplayPhone}
              saveUsernameExists={props.saveUsernameExists}
              saveAccountLocked={props.saveAccountLocked}
              saveStep={props.saveStep}
              saveUsername={props.saveUsername}
              saveSignInType={props.saveSignInType}
              savePayload={props.savePayload}
              showAlert={showAlert}
            />
            <div className="create-account-grid">
            <Button tabIndex={0} className='create-account-button' id={showAlert? 'alert' :'create-account'} type='create'>
              <a className = "create-account" href={createAccountHref} onClick = {props.saveURI}>Create Account</a>
            </Button>
            </div>
          </div>
          <div className="middle-column" id={showAlert ? 'alert-middle' : 'alert-middle-disable'}>
            <div className="vertical-line vertical-top"></div>
            <div className="or">or</div>
            <div className="vertical-line vertical-bottom"></div>
          </div>
          <div className="social-column">
            <div className="sign-in-apple top-social" id={showAlert ? 'alert-apple-disable' :'alert-apple'}>
              {appVars.getIncludeSignIn("APPLE") === true && <AppleButton />}
            </div>
            <div className="sign-in-google middle-social" id={showAlert ? 'alert-google-disable' :'alert-google'}>
              {appVars.getIncludeSignIn("GOOGLE") === true && <GoogleButton />}{" "}
              <br />
            </div>
            <div className="sign-in-facebook bottom-social" id={showAlert ? 'alert-facebook-disable' :'alert-facebook'}>
              {appVars.getIncludeSignIn("FACEBOOK") === true && (
                <FacebookButton />
              )}{" "}
              <br />
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-text">
        <div className="bottom-text-left" id={showAlert ? 'bottom-text-left-alert' : 'bottom-text-left'}>
          You can use your My Lexus or My Toyota or SmartPath{" "}
          <br className="mobile-br" /> account information to log in.
        </div>
        <br className="mobile-br" />
        <div role="navigation" className="bottom-text-right">
          {/* <a className = "bottom-link bottom-link-login" href="https://www.toyota.com/owners/register">Create an Account</a> */}
          <a
            className="bottom-link bottom-link-login"
            href={appVars.getResendActivationEmailURL(props.style)}
            id={showAlert? 'alert-activate' : 'activate'}
            onClick={props.saveURI}
          >
            {" "}
            Activate Account<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px"/>
          </a>
          <a
            className="bottom-link bottom-link-login"
            id={showAlert? 'alert-support' : 'support'}
            href="https://www.toyota.com/support/contact-us"
          >
            Support<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px"/>
          </a>
        </div>
      </div>
    </div>
  );
};

export default LoginPageViewMobile;
